function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "IMG_01",
  transform: "translate(259 142)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_Box",
  transform: "translate(-259 -142)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1,
  opacity: 0
}, /*#__PURE__*/React.createElement("rect", {
  width: 640,
  height: 376,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 639,
  height: 375,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "_01_Icon",
  "data-name": "01_Icon",
  d: "M13.077,6.5C12.821-.212,7.97-5.274,1.794-5.275L-25.745-5.28A45.074,45.074,0,0,0-17.62-30.993v-10.32a12.878,12.878,0,0,0-3.621-9.039,12.337,12.337,0,0,0-8.92-3.76h0c-8.752,0-11.367,6.975-13.675,13.128l-.1.262C-46.9-32.584-51.376-20.286-65.86-13.3L-74.513-9.09a5.459,5.459,0,0,0-1.608-3.647A5.458,5.458,0,0,0-80-14.353l-15.856,0h0A12.908,12.908,0,0,0-108.911-1.311l-.012,54.117A12.911,12.911,0,0,0-95.878,65.857l15.857,0a5.5,5.5,0,0,0,5.467-4.909L-55.971,65.6a77.192,77.192,0,0,0,18.737,2.284l26.679,0h0a10.855,10.855,0,0,0,7.783-3.282,11.328,11.328,0,0,0,3.249-8A10.469,10.469,0,0,0-1.5,50.254,11.22,11.22,0,0,0,5.016,39.993a10.479,10.479,0,0,0-1.979-6.351A11.218,11.218,0,0,0,9.55,23.381a11.737,11.737,0,0,0-2.291-6.889A11.535,11.535,0,0,0,13.077,6.5M1.79,11.339l-14.85,0h-.467v.03a2.829,2.829,0,0,0-2.515,2.95,2.854,2.854,0,0,0,2.98,2.982H-1.735a5.212,5.212,0,0,1,5.073,5.327,5.414,5.414,0,0,1-1.506,3.8,4.936,4.936,0,0,1-3.566,1.524h0l-11.959,0c-2.295,0-3.375,0-3.9.066v-.066s-.008,0-.008,0a2.958,2.958,0,0,0-2.146.827,2.964,2.964,0,0,0-.829,2.153A2.853,2.853,0,0,0-17.6,33.908l11.327,0A4.937,4.937,0,0,1-2.7,35.438a5.413,5.413,0,0,1,1.505,3.8,5.413,5.413,0,0,1-1.506,3.8A4.934,4.934,0,0,1-6.269,44.56H-10.8l-11.326,0h-.481v.032a2.827,2.827,0,0,0-2.5,2.948,2.851,2.851,0,0,0,2.979,2.982l11.326,0A4.935,4.935,0,0,1-7.235,52.05a5.415,5.415,0,0,1,1.505,3.8,6.308,6.308,0,0,1-1.524,4.068A4.716,4.716,0,0,1-10.8,61.676h0l-26.679-.006a68.416,68.416,0,0,1-17.25-2.254l-20.038-5.2.011-56.737,11.315-5.409c16.91-8.059,22.113-22.8,24.9-30.7l.4-1c1.806-4.571,3.365-8.519,7.98-8.519h0a6.8,6.8,0,0,1,6.583,6.837l0,10.321A40.624,40.624,0,0,1-31.049-7.861l-2.723,3.722a2.727,2.727,0,0,0-.379,2.684A2.8,2.8,0,0,0-31.431.68L2.043.686A5.21,5.21,0,0,1,7.116,6.014,5.4,5.4,0,0,1,1.79,11.339m-104.741-12.9a7.068,7.068,0,0,1,2.036-5.051,7.069,7.069,0,0,1,5.05-2.034h0l15.393,0L-80.484,59.4l-15.857,0v.236a7.011,7.011,0,0,1-4.587-2.021,7.074,7.074,0,0,1-2.035-5.054Z",
  transform: "translate(109.923 58.112)",
  fill: "#333330"
}));

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 376,
    viewBox: "0 0 640 376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.c1fe754184e4f3a081b5fde1858ea939.svg";
export { ForwardRef as ReactComponent };